// // The usage of Switch class:

// const exampleSwitch = new Switch({
//     targetId: 'my-target', // optional, ID of the target, also can be set in button's href, default: 'switch-target'
//     buttonId: 'my-button', // optional, ID of the toggle button
//     state: 1, // optional, initial state of the switch, deault is 0
//     activeClass: 'menu-open', // optional, default is 'active', this class will be toggled on the target and toggle-button
//     onFunction: myFunction, // optional, this function will be called when the switch is turned on
//     offFunction: myOtherFunction, // optional, this function will be called when the switch is turned off
// });

// document.addEventListener("DOMContentLoaded", function() {
//     exampleSwitch.init();
// }

class Switch {


    constructor(set) {

        set.state ? this._state = 1 : this._state = 0;

        this._buttonId = set.buttonId.trim();
        this._button =  document.getElementById( this._buttonId );

        
        if ( typeof( set.targetId ) === 'undefined' ) {
            let href = this._button.getAttribute("href");
            if (href.charAt(0) === "#" && href.length > 1) {
                this._targetId = href.substring(1);
            }
        } else if( typeof( set.targetId ) === 'string' && typeof( set.targetId.trim().charAt(0) ) !== "number" ) {
            this._targetId = set.targetId.trim();
        } else {
            this._targetId = "switch-target";
        }

        this._target = document.getElementById( this._targetId );

        typeof(set.activeClass) === 'string' && set.activeClass.trim().length ? this._activeClass = set.activeClass.trim() : this._activeClass = 'active';

        typeof(set.onFunction) === 'function' ? this._onFunction = set.onFunction : this._onFunction = null;

        typeof(set.offFunction) === 'function' ? this._offFunction = set.offFunction : this._offFunction = null;

    }

    get button() {
        return this._button;
    }

    set button(newButtonId) {
        this._buttonId = newButtonId.trim();
        this.init();
    }

    get target() {
        return this._target;
    }
    get targetId() {
        return this._targetId;
    }

    set target(newTargetId) {
        this._targetId = newTargetId.trim();
        this.refresh();
    }

    get state() {
        return this._state;
    }

    set state(newState) {
        newState ? this._state = 1 : this._state = 0;
        this._state ? this.on() : this.off();
    }

    on() {
        if (!this._state) {
            this._state = 1;
            this.refresh();
        }
    }

    off() {
        if (this._state) {
            this._state = 0;
            this.refresh();
        }
    }

    toggle() {
        this._state ? this._state = 0 : this._state = 1;
        this.refresh();
    }
    
    refresh(init) {
        if (typeof(init) !== "boolean") {init = false;}
        this._button = document.getElementById( this._buttonId );
        this._target = document.getElementById( this._targetId );
        if (this._state) {
            if (this._button) { this._button.classList.add(this._activeClass); }
            if (this._target) { this._target.classList.add(this._activeClass); } 
            if (this._onFunction) { this._onFunction(); }
        } else {
            if (this._button) { this._button.classList.remove(this._activeClass); }
            if (this._target) { this._target.classList.remove(this._activeClass); }
            if (this._offFunction && !init) { this._offFunction(); }
        }
    }
    
    init() {
        this.refresh(true);
        if (this._button) {
            let that = this;
            this._button.addEventListener('click',function(e){
                e.preventDefault();
                that.toggle();
            });
        }
    }

    report() {
        this.refresh();
        console.log('________________________')
        console.log('Switch report:')
        console.log('State of the switch: '+this._state);
        this._button ? console.log("Button ID: " + this._button.id) : console.log('Button not found');
        this._target ? console.log("Target ID: " + this._target.id) : console.log('Target not found');
        console.log("Active Class: " + this._activeClass);
        console.log("On-function: " + this._onFunction);
        console.log("Off-function: " + this._offFunction);
        console.log('________________________')
    }

}





